import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { EtiquetadoService } from "../../../services/etiquetado.service";
import { SpinnerService } from 'shared-components';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-reimp-consumos',
    templateUrl: './reimpresiones.component.html'
})
export class ReimpresionesConsumoComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    public reimpresiones = new Array<any>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    @Input() consumoId;

    @Output() refresh = new EventEmitter<boolean>();

    constructor(
        private readonly _translate: TranslateService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService
    ) { }

    ngOnInit() {
        this.getReimpresiones();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public getReimpresiones() {
        let filters = {
            consumoId: this.consumoId
        };
        this._spinnerService.showSpinner();
        this._etiquetadoService.getReimpresiones(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.length;
            this.reimpresiones = resp.lista;
        });
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
    }

    public showSeriados(i) {
        this.pestanaActiva[i] = 1;
    }

    public close() {
        this.dropdownSection = -1;
        this.refresh.emit();
    }

}
